module.exports = __webpack_public_path__ + "img/horizontal_7_1_3.c05b5a60.png";